import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/products", label: "Products" },
  { to: "/industries", label: "Industries" },
  { to: "/eaas", label: "Energy-as-a-Service" },
  { to: "/roi", label: "ROI Calculator" },
  { to: "/assessment", label: "Free Assessment" },
  { to: "/investors", label: "Investors" },
  { to: "/careers", label: "Careers" },
  { to: "/blog", label: "Blog" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 glass" data-testid="site-header">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="logo-link">
          <img src="/tratou-logo.png" alt="Tratou Energy" className="h-7 md:h-8 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) =>
                `px-3 py-2 text-xs font-mono uppercase tracking-[0.16em] transition ${
                  isActive ? "text-tratou-green" : "text-tratou-dim hover:text-white"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/contact" className="btn-secondary !py-2.5 !px-4" data-testid="header-quote-btn">Get a Quote</Link>
          <Link to="/contact?intent=demo" className="btn-primary !py-2.5 !px-4" data-testid="header-demo-btn">Book Demo</Link>
        </div>

        <button
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
          className="lg:hidden p-2 border border-white/10"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-tratou-deep" data-testid="mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `py-3 text-sm font-mono uppercase tracking-[0.16em] ${
                    isActive ? "text-tratou-green" : "text-tratou-dim"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <div className="flex gap-2 pt-3">
              <Link to="/contact" onClick={() => setOpen(false)} className="btn-secondary flex-1 !py-3">Quote</Link>
              <Link to="/contact?intent=demo" onClick={() => setOpen(false)} className="btn-primary flex-1 !py-3">Demo</Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
